import * as React from "react";
import { connect } from "react-redux";
import { ICoworkBranch } from "shared/model/ICoworkSpace";

import { IState } from "../../../../state/modules";
import ApplicationsSelectors from "../../../../state/modules/applications/ApplicationsSelectors";
import { Dispatch } from "../../../../state/store/store";
import BranchSelector from "./BranchSelector";

interface IProps {
  branches?: ICoworkBranch[];
  selectedBranch?: ICoworkBranch;
  setCurrentBranch?: (params: { branch: ICoworkBranch }) => void;
  currentCoworkName?: string;
  enableSelection?: boolean;
}

@(connect(
  (state: IState, ownProps: IProps): Partial<IProps> => ({
    branches: ApplicationsSelectors.allBranches(state.applications),
    selectedBranch: ApplicationsSelectors.currentCoworkBranch(
      state.applications
    ),
    setCurrentBranch: Dispatch.applications.setCurrentBranch,
    currentCoworkName: ApplicationsSelectors.currentCoworkDisplayName(
      state.applications
    ),
    enableSelection: ApplicationsSelectors.canCurrentUserSelectFromMultipleBranches(
      state
    )
  })
) as any)
export default class BranchSelectorContainer extends React.Component<IProps> {
  public render() {
    const {
      branches,
      selectedBranch,
      currentCoworkName,
      enableSelection
    } = this.props;
    if (branches!.length > 0 && selectedBranch) {
      return (
        <BranchSelector
          branches={branches!}
          currentCoworkName={currentCoworkName!}
          selectedBranch={selectedBranch!}
          enableSelection={enableSelection!}
          onBranchSelected={this.onBranchSelected}
        />
      );
    } else {
      return null;
    }
  }

  private onBranchSelected = (branch: ICoworkBranch) => {
    const { setCurrentBranch, selectedBranch } = this.props;
    if (branch.name !== selectedBranch!.name) {
      setCurrentBranch!({ branch });
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/Header/components/BranchSelector/BranchSelectorContainer.tsx